import * as ActionTypes from '../constants';
import axios from 'axios'; 
import { baseUrl,getUserToken } from './index'; 



const dispatchRequestGetJwPlayerSourceFiles = () => ({
    type:ActionTypes.REQUEST_GET_SOURCE_FILES_WITH_JW_MEDIA_ID,
    
})

const dispatchReceivedGetJwPlayerSourceFiles = res =>({
    type:ActionTypes.RECEIVED_GET_SOURCE_FILES_WITH_JW_MEDIA_ID,
    res
})

const dispatchErrorGetJwPlayerSourceFiles = (err) => ({
    type:ActionTypes.ERROR_GET_SOURCE_FILES_WITH_JW_MEDIA_ID,
    err
})

const dispatchClearGetJwPlayerSourceFiles= () => ({
    type: ActionTypes.CLEAR_GET_SOURCE_FILES_WITH_JW_MEDIA_ID
})

export const clearGetJwPlayerSourceFiles = () => dispatchClearGetJwPlayerSourceFiles();

export const getGetJwPlayerSourceFiles = (mediaId) => dispatch => {

    dispatch(dispatchRequestGetJwPlayerSourceFiles());   

    // const data = {course_id: courseId};

    getUserToken()
        .then( authKey => {
            const options = {
                method: 'get',
                url: `https://cdn.jwplayer.com/v2/media/6C840qwR`,
                // headers: {
                //     'Authorization': `Bearer ${authKey}`
                // }
            }
            return axios(options)
                .then(({data}) => {
                    dispatch(dispatchReceivedGetJwPlayerSourceFiles(data))
                })
        })
        .catch(e => dispatch(dispatchErrorGetJwPlayerSourceFiles(e)));    
}
